module.exports = __webpack_public_path__ + "static/media/34.6e780732.JPG";